import { Chip, Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";

export default () => (
	<CssColumnGrid columns={2}>
		<Text semiBold text="not localized" />
		<Text semiBold text="localized" />
		<Chip
			label="not localized"
		/>
		<Chip res="Resource" resParams={["Chip"]} />
	</CssColumnGrid>
);